module.exports = __webpack_public_path__ + "img/warning.fa342c41.svg";